import { ReactComponent as SimeraDark } from '$icons/simera-dark logo.svg';

const HeaderDefault = () => {
  return (
    <div className="flex justify-between items-center bg-white h-20 px-4 md:px-8">
      <SimeraDark className="w-36 md:w-52" />
    </div>
  );
};

export default HeaderDefault;
